import { Dispatch } from "redux";
import { contractService } from "../../../../configs/constants";
import axios from "../../../../utils/axiosInceptor";
import * as action_types from "./constants";
import { message as antdMessage } from "antd";

export type GetBookingRenewalFormsParams = {
  limit: number;
  page?: number;
  value?: string;
  field?: string;
  usagesType?: string;
  propertyId?: string | number;
  unitId?: string | number;
  exportData?: boolean | null;
  totalCount?: number | null;
  setExportData?: (v: boolean) => void;
  setIsLoading?: (loading: boolean) => void;
  renewalColumns?: any[] | null;
};

const appendFilterParams = (
  params: URLSearchParams,
  usagesType?: string,
  propertyId?: string | number,
  unitId?: string | number,
) => {
  if (usagesType && usagesType !== "" && usagesType !== "all") {
    params.append("usagesType", String(usagesType));
  }
  if (propertyId !== "" && propertyId !== undefined && propertyId !== null && propertyId !== "all") {
    params.append("propertyId", String(propertyId));
  }
  if (unitId !== "" && unitId !== undefined && unitId !== null && unitId !== "all") {
    params.append("unitId", String(unitId));
  }
};

export const getBookingRenewalForms =
  ({
    limit,
    page = 1,
    value = "",
    field = "",
    usagesType = "",
    propertyId = "",
    unitId = "",
    exportData = null,
    totalCount = null,
    setExportData,
    setIsLoading,
    renewalColumns = null,
  }: GetBookingRenewalFormsParams) =>
  async (dispatch: Dispatch) => {
    try {
      const params = new URLSearchParams();
      params.append("limit", String(limit));
      params.append("page", String(page));

      if (field) {
        params.append("searchby", String(field));
        params.append("text", value !== undefined && value !== null ? String(value) : "");
      }

      appendFilterParams(params, usagesType, propertyId, unitId);

      if (exportData && renewalColumns?.length) {
        const checkedColumns = renewalColumns
          .filter((col) => col.checked && col.headerName !== "Actions")
          .map((col) => col.headerName)
          .join(", ");
        params.append("exportData", String(exportData));
        params.append("columns", checkedColumns);
        if (totalCount != null) {
          params.append("totalCount", String(totalCount));
        }
      }

      const url = `${contractService}/booking/renewalBooking?${params.toString()}`;

      const {
        data: { result },
      } = await axios.get(url);

      if (result) {
        if (exportData === true) {
          antdMessage.success(result);
          setExportData?.(false);
        } else {
          dispatch({
            type: action_types.GET_BOOKINGRENEWALFORMS,
            data: result,
          });
        }
      }
    } catch (error) {
      // keep existing behavior: no toast here
    } finally {
      setIsLoading?.(false);
    }
  };

export const getBookingPendingReq = () => async (dispatch) => {
  const url = `${contractService}/booking?managerApproval=enable`;
  const {
    data: { result },
  } = await axios.get(url);

  if (result) {
    dispatch({
      type: action_types.GET_BOOKING_REQUESTS,
      data: result,
    });
  }
};

export const getLeasePendingReq = () => async (dispatch) => {
  const url = `${contractService}/booking?leaseManagerApproval=enable`;
  const {
    data: { result },
  } = await axios.get(url);

  if (result) {
    dispatch({
      type: action_types.GET_LEASE_REQUESTS,
      data: result,
    });
  }
};

export const getPlanPendingReq = () => async (dispatch) => {
  const url = `${contractService}/booking?paymentPlanApproval=enable`;
  const {
    data: { result },
  } = await axios.get(url);

  if (result) {
    dispatch({
      type: action_types.GET_PLAN_REQUESTS,
      data: result,
    });
  }
};

export const getRenewalPendingReq = () => async (dispatch) => {
  const url = `${contractService}/booking/renewalBooking?leaseManagerApproval=enable`;
  const {
    data: { result },
  } = await axios.get(url);

  if (result) {
    dispatch({
      type: action_types.GET_RENEWAL_REQUESTS,
      data: result,
    });
  }
};

export const sendTenantInvite = async (data, _successMessage) => {
  try {
    const url = `${contractService}/user/sendInvite`;
    const { status } = await axios.post(url, data);

    return status;
  } catch (error) {}
};

export const updateBookingStatus = async (leaseId, payload) => {
  try {
    const url = `${contractService}/booking/${leaseId}`;
    const { status } = await axios.patch(url, payload);

    return status;
  } catch (error) {}
};

export const CreateEjariContract = async (leaseId) => {
  const url = `${contractService}/ejari/createEjariContract`;
  const payload = { leaseId: leaseId };
  const { data } = await axios.post(url, payload);
  return data;
};

export const DownloadEjariContract = async (leaseId) => {
  const url = `${contractService}/ejari/downloadEjariContract`;
  const payload = { leaseId: leaseId };
  const { data } = await axios.post(url, payload);
  return data;
};

export const UploadSignedEjariContract = async (payload) => {
  const url = `${contractService}/ejari/uploadSignedFile`;
  const status = await axios.post(url, payload, { headers: { "Content-Type": "multipart/form-data" } });
  return status;
};

export const UploadEjariCertificate = async (payload) => {
  const url = `${contractService}/ejari/uploadEjariFile`;
  const status = await axios.post(url, payload, { headers: { "Content-Type": "multipart/form-data" } });
  return status;
};

export const ActivateEjari = async (leaseId) => {
  const url = `${contractService}/booking/${leaseId}`;
  const payload = { status: "leaseActive" };
  const { data } = await axios.patch(url, payload);
  return data;
};

export const PrintEjariCertificateContract = async (leaseId) => {
  const url = `${contractService}/ejari/printEjariCertificateContract`;
  const payload = { leaseId: leaseId };
  const { data } = await axios.post(url, payload);
  return data;
};
